import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/**
 * Mercado Livre do produto, em diálogo.
 *
 * É só a moldura: o conteúdo é o `app-produto-mercado-livre`, o mesmo componente que pode ser
 * embutido em qualquer tela. Assim o mapeamento segue o padrão das outras opções do produto
 * (Tributação, Preços, Imagens), que também são diálogos, sem duplicar a lógica.
 */
@Component({
  selector: 'app-produto-mercado-livre-popup',
  templateUrl: './produto-mercado-livre-popup.component.html',
  styleUrls: ['./produto-mercado-livre-popup.component.scss']
})
export class ProdutoMercadoLivrePopupComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ProdutoMercadoLivrePopupComponent>
  ) { }

  get produtoId(): number {
    return this.data?.payload?.id;
  }
}
